import { IAuthState } from 'store/auth/reducer';

export const isLoggedIn = (values: IAuthState): boolean => !! values.data?.token;

export const getToken = (values: IAuthState): string|undefined => values.data?.token;

export const isLoading = (values: IAuthState): boolean => !! values.loading;
